import * as angular from 'angular';
import { Component, Input, OnInit, Inject, Output, EventEmitter } from 'ng-metadata/core';
import { MediaSourceDocument } from './media-source-document.model';
import './media-source-document.component.scss';

/**
 * @ngdoc directive
 * @name mwMediaContactDocument
 * @module mw.components.contentDocuments
 *
 * @param {object} [source] - The content document.
 * @param {boolean} [is-selectable=false] - Control if the document is selectable (if true, shows a checkbox).
 * @param {boolean} [is-avatar-visible=true] - Control if the avatar is visible.
 * @param {boolean} [is-beats-visible=true] - Control if the beats are visible.
 * @param {expression} [on-select-toggle] - Angular expression to evaluate when the selected state of the document is toggled. $event is a boolean indicating selected(true)/unselected(false) state.
 *
 * @description
 * `<mw-media-source-document>` is a component used to display a single media source document.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

const template = `
    <div class="mw-media-source-document" ng-class="{'mw-content-document--avatar-is-visible':$ctrl.isAvatarVisible, 'mw-media-source-document--is-selectable': $ctrl.isSelectable}">
        <div class="mw-content-document__main-container" layout="row">
            <div class="mw-media-source-document__checkbox-container" ng-if="::$ctrl.isSelectable">
                <md-checkbox
                    aria-label="Select Contact"
                    ng-checked="$ctrl.source.selected"
                    ng-click="::$ctrl.handleSelectToggle($ctrl.source)"
                    class="md-primary">
                </md-checkbox>
            </div>
            <div class="mw-media-source-document__column-two" flex="100">
                <mw-media-source-document-header>
                    <mw-content-document-source-avatar
                        ng-if="::$ctrl.isAvatarVisible"
                        source-name="::$ctrl.source.initial">
                    </mw-content-document-source-avatar>
                    <mw-content-document-author
                        class="mw-media-source-document__author"
                        url="::$ctrl.source.url"
                        id="::$ctrl.source.id"
                        text="::$ctrl.source.name">
                    </mw-content-document-author>
                    <mw-media-source-document-geofocus
                        text="::$ctrl.source.geoFocus">
                    </mw-media-source-document-geofocus>
                    <mw-media-source-document-web
                        url="::$ctrl.source.url">
                    </mw-media-source-document-web>
                    <mw-media-source-document-address
                        address="::$ctrl.source.location">
                    </mw-media-source-document-address>
                    <mw-content-document-actions>
                        <ng-transclude ng-transclude-slot="mwContentDocumentActions"></ng-transclude>
                    </mw-content-document-actions>
                </mw-media-source-document-header>
                <div class="mw-content-document__content">
                    <ng-transclude ng-transclude-slot="mwContentDocumentKeywords"></ng-transclude>
                </div>
                <ng-transclude class="mw-content-document__footer-slot" ng-transclude-slot="mwContentDocumentFooter">
                </ng-transclude>
            </div>
        </div>
        <mw-content-document-tray>
            <ng-transclude ng-transclude-slot="mwContentDocumentTrayContent">
            </ng-transclude>
        </mw-content-document-tray>
    </div>
`;

@Component({
    selector: 'mw-media-source-document',
    template: template,
    legacy: {
        transclude: {
            'mwContentDocumentActions': '?mwContentDocumentActions',
            'mwContentDocumentKeywords': '?mwContentDocumentKeywords',
            'mwContentDocumentFooter': '?mwContentDocumentFooter',
            'mwContentDocumentTrayContent': '?mwContentDocumentTrayContent'
        }
    }
})
export class MediaSourceDocumentComponent implements OnInit {


    private headerElement: HTMLElement;

    @Input('<') source: MediaSourceDocument;
    @Input('<') isSelectable: boolean;
    @Input('<') isAvatarVisible: boolean;

    @Output() onSelectToggle = new EventEmitter<{ source: MediaSourceDocument }>();

    constructor(
        @Inject('$translate') private $translate,
        @Inject('$element') private $element,
    ) {
        'ngInject';
    }

    ngOnInit() {
        this.isSelectable = this.isSelectable === true;
        this.isAvatarVisible = this.isAvatarVisible  === true;
    }

    handleSelectToggle(source: MediaSourceDocument) {
        this.onSelectToggle.emit({source});
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/media-source-document.component.ts